import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import data from "../../Data/licensesData.json";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

export default function Licenses() {
  useSEO(seoConfig.licenses);

  return (
    <section className="licenses">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Правовая информация и лицензии
      </h1>

      <Accordion data={data} />
    </section>
  );
}
